import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router  } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { RestDataService } from './rest-data.service';

@Injectable()
export class AnalyticsRoleGuard implements CanActivate {
  constructor(private restService:RestDataService,
    private router:Router){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      this.restService.tokenParse();
      if(this.restService.userDetail && this.restService.userDetail.analyticsPermission){
        return true;
      }else{
        this.router.navigateByUrl('/dash/workspace')
        return false
      }
  }
}
